import { heartBeatInterval } from "common/globals";

/**
 * A student heartbeat arrives every 3s. Two missed beats plus a short grace
 * drops them from Online Students within a few seconds of leaving.
 */
export const STUDENT_PRESENCE_STALE_MS = heartBeatInterval * 2 + 1000;

export function isStudentPresent(
  lastHeartbeatTime: Date | string | undefined | null,
  now: number,
  staleMs: number = STUDENT_PRESENCE_STALE_MS,
): boolean {
  if (!lastHeartbeatTime) return false;
  const seen = new Date(lastHeartbeatTime).getTime();
  if (!Number.isFinite(seen)) return false;
  return now - seen <= staleMs;
}
